import React from 'react';
import GetInTouch from '../../common/GetInTouch';
import phoneImage from '../../../assets/images/home/mobile-phone.webp';

const HomeGetInTouch = () => {
  const getInTouchData = {
    title: "Get in Touch",
    description: "Have questions about SimFinance? Our team is here to help.",
    contactInfo: [
      "Phone: [Ghana phone number]",
      "Hours: Monday-Friday, 8am-6pm",
      "Email: partners@simfinancegh.com",
      "Visit Us: [Office Address in Ghana]"
    ],
    image: phoneImage,
    gradient: "from-purple-900 via-purple-800 to-orange-500"
  };

  return <GetInTouch {...getInTouchData} />;
};

export default HomeGetInTouch;